











































import { computed, defineComponent, ref, Ref, PropType } from '@vue/composition-api';
import { SortAscendingIcon, SortDescendingIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'Sort',
    model: { prop: 'sort', event: 'change' },
    props: {
        sort: {
            type: String,
            required: true,
        },
        options: {
            type: Array as PropType<{ label: string; field: string; asc: boolean }[]>,
            required: true,
        },
    },
    components: { SortAscendingIcon, SortDescendingIcon },
    setup(props, { emit }) {
        const isSortOpen: Ref<boolean> = ref<boolean>(false);

        const sortBy = computed(() =>
            props.options.find(
                (sortOption: { label: string; field: string; asc: boolean }) => sortOption.label === props.sort,
            ),
        );

        const handleChangeSelect = (label: any) => {
            emit('change', label);
            isSortOpen.value = false;
        };
        return { sortBy, isSortOpen, handleChangeSelect };
    },
});
